import React, { Fragment, useRef, useState, useEffect, useContext } from 'react';
import { AuthContext } from '../contexts/auth';
import { Dialog, Transition } from '@headlessui/react';
import { DocumentPlusIcon, CheckIcon, ClockIcon } from '@heroicons/react/24/outline';
import { getJustificationsCompanyList } from '../services/api_justifications';
import { listOrganizationalUnits } from "../services/api_org_unit";
import ComboboxAutocomplete from './combobox_autocomplete';
import { createEmployeeJustificationRequest } from '../services/api_justification_requests';
import Swal from 'sweetalert2';
import moment from 'moment';



const AddGiustificativoModal = ({ closeModalAddGiustificativi, dipendente, formattedDay, selectedJustification, onSaveJustificationRequest, selectedUnit }) => {
    const cancelButtonRef = useRef(null);
    const { token } = useContext(AuthContext);
    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(false);
    const [error, setError] = useState('');
    const [giustificativi, setGiustificativi] = useState([]);
    const [giustificativoSelected, setGiustificativoSelected] = useState(null);
    const [startTime, setStartTime] = useState('');
    const [endTime, setEndTime] = useState('');
    const [startDay, setStartDay] = useState(formatDate(formattedDay));
    const [endDay, setEndDay] = useState(formatDate(formattedDay));
    const [note, setNote] = useState('');
    const [timeError, setTimeError] = useState('');
    const [isInputReset, setIsInputReset] = useState(false);
    const [units, setUnits] = useState([]);
    const [tempSelectedUnit, setTempSelectedUnit] = useState(null);

    
    useEffect(() => {
        if (selectedUnit) {
            setTempSelectedUnit(selectedUnit);
        }
    }, [selectedUnit]);

    function formatDate(dateString) {
        const date = moment(dateString, 'YYYY-MM-DD', true);
        return date.isValid() ? date.format('DD/MM/YYYY') : '';
    }

    useEffect(() => {
        setIsLoading(true);
        setIsError(false);

        const fetchData = async () => {
            try {
                const giustificativi = await getJustificationsCompanyList(token);
                setGiustificativi(giustificativi);
            } catch (error) {
                console.error('Error fetching justifications:', error);
                setIsError(true);
            } finally {
                setIsLoading(false);
            }
        };

        fetchData();
    }, [token]);

    useEffect(() => {

    }, [giustificativoSelected]);

    useEffect(() => {
        async function fetchData() {
            try {
                setIsLoading(true);
                const unitsData = await listOrganizationalUnits(token, true);
                setUnits(unitsData.data);
                setIsLoading(false);
            } catch (error) {
                console.error('Error fetching units:', error);
                setError(true);
                setIsLoading(false);
            }
        }
        fetchData();
    }, [token]);

    const handleSelectUnit = (selected) => {
        setTempSelectedUnit(selected);
    };

    const handleWorkTimeBlur = (field) => {
        let formattedTime = field === 'start' ? startTime : endTime;
        formattedTime = formattedTime.replace(/\D/g, '');

        while (formattedTime.length < 4) {
            formattedTime += '0';
        }

        formattedTime = formattedTime.slice(0, 4);
        const hours = formattedTime.slice(0, 2);
        const minutes = formattedTime.slice(2);
        formattedTime = `${hours}:${minutes}`;

        const isValidTime = /^([01]?[0-9]|2[0-4]):[0-5][0-9]$/.test(formattedTime);

        if (!isValidTime) {
            if (field === 'start') {
                setStartTime('');
            } else {
                setEndTime('');
            }
            return;
        }

        if (field === 'start') {
            setStartTime(formattedTime);
        } else {
            setEndTime(formattedTime);
        }
    };

    const handleStartTimeChange = (e) => {
        let inputValue = e.target.value;
        inputValue = inputValue.replace(/\D/g, '');
        inputValue = inputValue.slice(0, 4);
        let formattedTime = inputValue.replace(/(\d{2})(\d{0,2})/, "$1:$2");

        if (inputValue.length <= 2 && e.target.value.length < formattedTime.length) {
            formattedTime = formattedTime.replace(":", "");
        }

        setStartTime(formattedTime);

        if (endTime && formattedTime >= endTime) {
            setTimeError("L'orario di inizio deve essere precedente all'orario di fine.");
        } else {
            setTimeError('');
        }
    };

    const handleEndTimeChange = (e) => {
        let inputValue = e.target.value;
        inputValue = inputValue.replace(/\D/g, '');
        inputValue = inputValue.slice(0, 4);
        let formattedTime = inputValue.replace(/(\d{2})(\d{0,2})/, "$1:$2");

        if (inputValue.length <= 2 && e.target.value.length < formattedTime.length) {
            formattedTime = formattedTime.replace(":", "");
        }

        setEndTime(formattedTime);

        if (startTime && formattedTime <= startTime) {
            setTimeError("L'orario di fine deve essere successivo all'orario di inizio.");
        } else {
            setTimeError('');
        }
    };


    const handleKeyDown = (e) => {
        const { name } = e.target;
    
        if (isInputReset) {
            if (name === 'startDay') {
                setStartDay('');
            } else if (name === 'endDay') {
                setEndDay('');
            }
            setIsInputReset(false);
        }
    };
      
    const handleBlur = () => {
        setIsInputReset(false);
    };

    const handleStartDayChange = (e) => {
        let inputValue = e.target.value;
        inputValue = inputValue.replace(/\D/g, '');
        if (inputValue.length > 2 && inputValue.length <= 4) {
          inputValue = `${inputValue.slice(0, 2)}/${inputValue.slice(2)}`;
        } else if (inputValue.length > 4) {
          inputValue = `${inputValue.slice(0, 2)}/${inputValue.slice(2, 4)}/${inputValue.slice(4)}`;
        }
        setStartDay(inputValue);
        if (endDay && inputValue.length === 10) {
            const [startDayPart, startMonth, startYear] = inputValue.split('/');
            const startDate = new Date(`${startYear}-${startMonth}-${startDayPart}`);
    
            const [endDayPart, endMonth, endYear] = endDay.split('/');
            const endDate = new Date(`${endYear}-${endMonth}-${endDayPart}`);
    
            if (startDate >= endDate) {
                setTimeError("La data di inizio deve essere precedente alla data di fine.");
            } else {
                setTimeError('');
            }
        }
    };
    
    const handleEndDayChange = (e) => {
        let inputValue = e.target.value;
        
        inputValue = inputValue.replace(/\D/g, '');
        
        if (inputValue.length > 2 && inputValue.length <= 4) {
            inputValue = `${inputValue.slice(0, 2)}/${inputValue.slice(2)}`;
        } else if (inputValue.length > 4) {
            inputValue = `${inputValue.slice(0, 2)}/${inputValue.slice(2, 4)}/${inputValue.slice(4)}`;
        }
        
        setEndDay(inputValue);
        
        if (startDay && inputValue.length === 10) {
            const [startDayPart, startMonth, startYear] = startDay.split('/');
            const startDate = new Date(`${startYear}-${startMonth}-${startDayPart}`);
            
            const [endDayPart, endMonth, endYear] = inputValue.split('/');
            const endDate = new Date(`${endYear}-${endMonth}-${endDayPart}`);
            
            if (endDate <= startDate) {
                setTimeError("La data di fine deve essere successiva alla data di inizio.");
            } else {
                setTimeError('');
            }
        }
    };
    
    const convertToISOFormat = (dateString) => {
        const [day, month, year] = dateString.split('/');
        return `${year}-${month}-${day}`;
    };
    
    const handleGiustificativoChange = (giustificativo) => {
        setGiustificativoSelected(giustificativo);
    
        if (!giustificativo?.has_hours) {
            setStartTime('00:00');
            setEndTime('24:00');
        } else {
            setStartTime('');
            setEndTime('');
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
    
        if (!startTime || !endTime || giustificativoSelected === null) {
            setTimeError("Compila tutti i campi obbligatori.");
            return;
        }

        if (!startDay || !endDay || !startTime || !endTime) {
            setTimeError("Data e orari devono essere specificati.");
            return;
        }

        let datetimeTo = convertToISOFormat(endDay);
        if (endTime === '24:00') {
            datetimeTo = moment(datetimeTo).add(1, 'days').format('YYYY-MM-DD')+'T00:00:00';
        } else {
            datetimeTo = `${datetimeTo}T${endTime}:00`;
        }
        
        const datetimeFrom = convertToISOFormat(startDay) + `T${startTime}:00`;
    
        const data = {
            datetime_from: datetimeFrom,
            datetime_to: datetimeTo,
            note,
            justification: giustificativoSelected ? giustificativoSelected.id : null,
            ou: tempSelectedUnit ? tempSelectedUnit.id : null,
        };

        const loader = Swal.fire({
            title: 'Salvataggio in corso...',
            html: 'Attendere',
            didOpen: () => {
                Swal.showLoading();
            },
            showConfirmButton: false,
            allowOutsideClick: false,
            allowEscapeKey: false,
        });
        
        try {
            await createEmployeeJustificationRequest(token, dipendente.id, data);
    
            await Swal.fire({
                icon: 'success',
                title: 'Salvato!',
                text: 'La richiesta di giustificativo è stata inserita',
                timer: 1000,
                showConfirmButton: false,
            });
            onSaveJustificationRequest(data, dipendente.id);

            closeModalAddGiustificativi();
            loader.close();
    
        } catch (error) {
            console.error('Failed to update justification:', error);
            loader.close();
            let errorMessage = 'Si è verificato un errore durante la modifica del giustificativo. Per favore riprova.';
            if (error.response && error.response.data) {
                const errorData = error.response.data;
                const errorMessages = [];
    
                Object.keys(errorData).forEach(key => {
                    const messageArray = errorData[key];
                    if (Array.isArray(messageArray)) {
                        errorMessages.push(...messageArray);
                    }
                });
    
                if (errorMessages.length > 0) {
                    errorMessage = errorMessages.join(' ');
                }
            }
    
            Swal.fire({
                icon: 'error',
                title: 'Errore',
                text: errorMessage,
                confirmButtonText: 'OK',
            });
        } finally {
            loader.close();
        }
    };
    
    

    return (
        <Transition.Root show={true} as={Fragment}>
            <Dialog as="div" className="fixed inset-0 overflow-y-auto top-10" style={{ zIndex: '150' }} onClose={() => {}} initialFocus={cancelButtonRef}>
                <div className="flex items-start justify-center min-h-screen px-4 text-center sm:block sm:p-0">
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <Dialog.Overlay className="fixed inset-0 bg-black opacity-30" />
                    </Transition.Child>

                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        enterTo="opacity-100 translate-y-0 sm:scale-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                        leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                    >
                        <div className="inline-block bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all w-2/3 sm:w-1/3 mt-20 sm:mt-30 top-0">
                            <div className="border-b border-gray-200 text-center flex items-center justify-center bg-indigo-200 py-3">
                                <DocumentPlusIcon className="h-5 w-5 text-indigo-700" /><span className='w-4'></span>
                                <Dialog.Title as="h3" className="text-lg font-semibold text-indigo-700">
                                    Aggiungi Giustificativo
                                </Dialog.Title>
                            </div>
                            <form onSubmit={handleSubmit} className='p-4'>
                                <div className='grid grid-cols-2 gap-3 w-full p-2 align-middle'>
                                    <div className='col-span-1 font-semibold text-sm text-gray-600 uppercase pt-1'>
                                        Dipendente
                                    </div>
                                    <div className='col-span-1 text-sm text-gray-600 flex-col items-center'>
                                        {dipendente.last_name && dipendente.first_name ? `${dipendente.last_name} ${dipendente.first_name}` : dipendente.cf}
                                    </div>
                                    <div className='col-span-1 font-semibold text-sm text-gray-600 uppercase pt-1'>
                                        Fasce orarie lavoro
                                    </div>
                                    <div className='col-span-1 text-sm flex-col items-center'>
                                        {selectedJustification && selectedJustification.time_slots && selectedJustification.time_slots.length > 0 ? (
                                            selectedJustification.time_slots
                                                .slice()
                                                .sort((a, b) => a.start_at.localeCompare(b.start_at)) // Ordina per orario di inizio
                                                .map((timeSlot, index) => (
                                                    <div key={index} className="mb-2 flex items-center">
                                                        <div>
                                                            <div className='flex items-center text-xs'>
                                                                {timeSlot.start_at} - {timeSlot.end_at}
                                                            </div>
                                                            {timeSlot.breaks && timeSlot.breaks.length > 0 && (
                                                                <ul>
                                                                    {timeSlot.breaks
                                                                        .slice()
                                                                        .sort((a, b) => a.start_at.localeCompare(b.start_at)) // Ordina anche le pause
                                                                        .map((breakItem, breakIndex) => (
                                                                            <li className='text-xs' key={breakIndex}>
                                                                                Pausa {breakItem.start_at} - {breakItem.end_at}
                                                                            </li>
                                                                        ))}
                                                                </ul>
                                                            )}
                                                        </div>
                                                    </div>
                                                ))
                                        ) : (
                                            <div className="text-sm text-gray-600">Nessun orario previsto</div>
                                        )}
                                    </div>

                                    <div className='col-span-1 items-center font-semibold text-sm text-gray-600 uppercase pt-1'>
                                        Giustificativo *
                                    </div>
                                    <div className='col-span-1 items-center'>
                                        {selectedJustification && selectedJustification.time_slots && selectedJustification.time_slots.length > 0 ? (
                                            <ComboboxAutocomplete
                                                options={giustificativi.map((giustificativo) => ({
                                                    id: giustificativo.id,
                                                    name: giustificativo.justification.description,
                                                    value: giustificativo.id,
                                                    has_hours: giustificativo?.justification?.has_hours
                                                }))}
                                                bgActiveColor="bg-indigo-100"
                                                textActiveColor="text-gray-900"
                                                placeholder='Seleziona il giustificativo...'
                                                onChange={(selectedOption) => {
                                                    setGiustificativoSelected(selectedOption ?? null);
                                                    handleGiustificativoChange(selectedOption);
                                                }}
                                                value={giustificativoSelected}
                                                displayValue={(giustificativoSelected) => {
                                                    const selectedOption = giustificativi.find(
                                                        (giustificativo) => giustificativo.id === giustificativoSelected?.id
                                                    );
                                                    return selectedOption ? selectedOption.justification.description : '';
                                                }}
                                                positionOptions='absolute'
                                                required
                                            />
                                        ) : (
                                            <ComboboxAutocomplete
                                                options={giustificativi
                                                    .filter(giustificativo => giustificativo.justification.strategy === 'increase')
                                                    .map((giustificativo) => ({
                                                        id: giustificativo.id,
                                                        name: giustificativo.justification.description,
                                                        value: giustificativo.id,
                                                        has_hours: giustificativo?.justification?.has_hours
                                                    }))
                                                }
                                                bgActiveColor="bg-indigo-100"
                                                textActiveColor="text-gray-900"
                                                placeholder='Seleziona il giustificativo...'
                                                onChange={(selectedOption) => {
                                                    setGiustificativoSelected(selectedOption ?? null);
                                                    handleGiustificativoChange(selectedOption);
                                                }}
                                                value={giustificativoSelected}
                                                displayValue={(giustificativoSelected) => {
                                                    const selectedOption = giustificativi.find(
                                                        (giustificativo) => giustificativo.id === giustificativoSelected?.id
                                                    );
                                                    return selectedOption ? selectedOption.justification.description : '';
                                                }}
                                                positionOptions='absolute'
                                            />
                                        )}
                                    </div>
                                    
                                    <div className='col-span-1 font-semibold text-sm text-gray-600 uppercase pt-1'>
                                        Dal giorno *
                                    </div>
                                    <div className='col-span-1 text-sm items-center w-full'>
                                        <div className="col-span-1 text-sm items-center" style={{ position: 'relative'}}>
                                            <input
                                                name='startDay' 
                                                type="text"
                                                placeholder='ggmmaaaa' 
                                                value={startDay || ''}
                                                onChange={handleStartDayChange}
                                                onKeyDown={handleKeyDown}
                                                onBlur={handleBlur}
                                                maxLength={10}
                                                className="mt-1 p-1 pl-4 border-gray-200 rounded-md focus:ring-indigo-500 block w-full shadow-md sm:text-sm required" 
                                            />
                                        </div>
                                    </div>
                                    <div className='col-span-1 font-semibold text-sm text-gray-600 uppercase pt-1'>
                                        Al giorno *
                                    </div>
                                    <div className='col-span-1 text-sm items-center w-full'>
                                        <div className="col-span-1 text-sm items-center" style={{ position: 'relative' }}>
                                            <input 
                                                name='endDay'
                                                type="text"
                                                placeholder='ggmmaaaa' 
                                                value={endDay || ''}
                                                onInput={handleEndDayChange}
                                                onKeyDown={handleKeyDown}
                                                onBlur={handleBlur}
                                                maxLength={10}
                                                className="mt-1 p-1 pl-4 border-gray-200 rounded-md focus:ring-indigo-500 block w-full shadow-md sm:text-sm required" 
                                            />
                                        </div>
                                    </div>
                              
                                    {giustificativoSelected && giustificativoSelected?.has_hours && (
                                        <>
                                            <div className='col-span-1 items-center font-semibold text-sm text-gray-600 uppercase pt-1'>
                                                Dalle ore *
                                            </div>
                                            <div className="col-span-1 text-sm items-center" style={{ position: 'relative' }}>
                                                <input 
                                                    type="text"
                                                    placeholder='hh:mm' 
                                                    value={startTime} 
                                                    onInput={handleStartTimeChange}
                                                    onBlur={() => handleWorkTimeBlur('start')}
                                                    className="mt-1 p-1 pl-4 border-gray-200 rounded-md focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-md sm:text-sm required" 
                                                    style={{ paddingRight: '2.5rem' }}
                                                    required
                                                />
                                                <span style={{ position: 'absolute', top: '50%', right: '8px', transform: 'translateY(-50%)' }}>
                                                <ClockIcon className='w-4 h-4' />
                                                </span>
                                            </div>      
                                            <div className='col-span-1 items-center font-semibold text-sm text-gray-600 uppercase pt-1'>
                                                Alle ore *
                                            </div>
                                            <div className='col-span-1 text-sm items-center' style={{ position: 'relative' }}>
                                                <input 
                                                    type="text"
                                                    placeholder='hh:mm' 
                                                    value={endTime} 
                                                    onInput={handleEndTimeChange} 
                                                    onBlur={() => handleWorkTimeBlur('end')}
                                                    className="t-1 p-1 pl-4 border-gray-200 rounded-md focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-md sm:text-sm required" 
                                                    style={{ paddingRight: '2.5rem' }}
                                                    required
                                                />
                                                <span style={{ position: 'absolute', top: '50%', right: '8px', transform: 'translateY(-50%)' }}>
                                                    <ClockIcon className='w-4 h-4' />
                                                </span>
                                            </div>
                                        </>
                                    )}

                                    <div className='col-span-1 items-center font-semibold text-sm text-gray-600 uppercase pt-1'>
                                        Note
                                    </div>
                                    <textarea 
                                        className='col-span-1 h-20 text-sm focus:ring-indigo-500 focus:border-indigo-500 border-gray-200 shadow-md rounded-md'
                                        value={note}
                                        onChange={(e) => setNote(e.target.value)}
                                    />
                                    <div className='col-span-1 items-center font-semibold text-sm text-gray-600 uppercase pt-1'>
                                        Associa Unità
                                    </div>
                                    <div className='col-span-1 items-center'>
                                        <ComboboxAutocomplete
                                            options={units}
                                            bgActiveColor="bg-indigo-100"
                                            textActiveColor="text-gray-900"
                                            placeholder="Seleziona l'Unità Organizzativa"
                                            onChange={handleSelectUnit}
                                            value={tempSelectedUnit}
                                            positionOptions='relative'
                                        />
                                    </div>
                                </div>
                            </form>

                            {timeError && <div className='justify-center flex text-xs text-red-500 pt-2'>Compila tutti i campi obbligatori</div> }

                            <div className="p-4 flex justify-center">
                                <button
                                    type="button"
                                    className="hover:bg-indigo-100 text-xs flex justify-center focus:ring-indigo-500 focus:border-indigo-500 items-center border border-gray-300 shadow-md rounded-md w-full text-gray-500 font-bold btn-xs p-2 mr-4"
                                    onClick={handleSubmit}
                                    ref={cancelButtonRef}
                                >   
                                    <CheckIcon className="h-4 w-4 mr-1 text-indigo-800" />
                                    SALVA
                                </button>
                                <button
                                    type="button"
                                    className="hover:bg-gray-100 text-xs flex justify-center focus:ring-indigo-500 focus:border-indigo-500 items-center border border-gray-300 shadow-md rounded-md w-full text-gray-500 font-bold btn-xs p-2"
                                    onClick={closeModalAddGiustificativi}
                                >
                                    ANNULLA
                                </button>
                            </div>
                        </div>
                    </Transition.Child>
                </div>
            </Dialog>
        </Transition.Root>
    );
};

export default AddGiustificativoModal;
